import React, { Fragment, useEffect } from 'react'
import { useTranslation } from 'src/utils/i18n'

function One() {
  const { t } = useTranslation('common')

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = '/dashboard'
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <Fragment>
      <div className={`w-[620px] lg:mt-[40px] Ssm:w-[100%] mx-auto justify-between overflow-auto setup Smd:flex overflow-auto p-[12px_15px_15px_15px] max-w-[1440px]`}>
        <div className={`w-full Ssm:w-[100%] mx-auto justify-between items-start setup Smd:flex`}>
          <div className={`w-[400px] mx-auto Dsm:w-[100%]`}>
            <div className={`Dsm:pt-[20px] Dsm:w-[96%] mx-auto`}>
              <div className='w-[129px] h-[129px] mx-auto flex justify-center'>
                <svg xmlns='http://www.w3.org/2000/svg' width='64' height='120' viewBox='0 0 64 120' fill='none'>
                  <path
                    d='M0 10C0 4.47715 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V110C64 115.523 59.5228 120 54 120H10C4.47715 120 0 115.523 0 110V10Z'
                    fill='#2A313B'
                  />
                  <path
                    d='M0 10C0 4.47716 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V44.9123L0 74.1053L0 10Z'
                    fill='#3D4550'
                  />
                  <path
                    d='M37.5943 57.475C37.5869 57.4731 37.5869 57.4657 37.5832 57.4565C37.3924 57.0616 37.0872 56.7333 36.7073 56.5143C36.3273 56.2952 35.8902 56.1957 35.4529 56.2286C34.8712 56.2808 34.3339 56.5609 33.958 57.0078C33.5821 57.4547 33.3982 58.0321 33.4464 58.6141C33.4742 58.9266 33.5574 59.2133 33.6924 59.474C33.9962 60.1771 34.0845 60.9546 33.9459 61.7078C33.8073 62.4611 33.4481 63.1562 32.9138 63.7051L27.0443 69.6745C25.5871 71.1539 23.2182 71.1539 21.7592 69.6745C20.3038 68.1951 20.3038 65.7911 21.7592 64.3098L23.9487 62.087L23.9357 62.0685C24.4406 61.6247 24.7346 60.9497 24.6828 60.2211C24.6624 59.9333 24.5855 59.6522 24.4564 59.3942C24.3273 59.1361 24.1485 58.906 23.9304 58.717C23.7122 58.5281 23.459 58.384 23.1851 58.2931C22.9112 58.2021 22.6221 58.166 22.3343 58.1869C21.7797 58.2295 21.263 58.4846 20.8919 58.8989L20.89 58.8952L18.658 61.1587C17.1344 62.7152 16.2812 64.8067 16.2812 66.9847C16.2812 69.1628 17.1344 71.2542 18.658 72.8108C19.4047 73.5752 20.2966 74.1826 21.2814 74.5972C22.2662 75.0119 23.324 75.2256 24.3925 75.2256C25.4611 75.2256 26.5188 75.0119 27.5036 74.5972C28.4884 74.1826 29.3804 73.5752 30.127 72.8108L36.0113 66.834C38.4782 64.3265 39.0108 60.615 37.6331 57.5693C37.6231 57.5373 37.6101 57.5045 37.5943 57.475ZM45.3482 46.2038C44.6015 45.4394 43.7096 44.8321 42.7248 44.4174C41.74 44.0027 40.6822 43.7891 39.6137 43.7891C38.5451 43.7891 37.4874 44.0027 36.5026 44.4174C35.5178 44.8321 34.6258 45.4394 33.8792 46.2038L27.9911 52.1806C25.5243 54.6845 24.9917 58.3959 26.3638 61.4398C26.3805 61.4712 26.3915 61.5045 26.4045 61.5396L26.4156 61.5581C26.8021 62.3459 27.6268 62.8563 28.5459 62.786C29.1276 62.7338 29.6649 62.4537 30.0408 62.0068C30.4167 61.5599 30.6006 60.9825 30.5524 60.4005C30.5267 60.1007 30.4432 59.8086 30.3064 59.5406C30.0023 58.8376 29.9139 58.06 30.0526 57.3067C30.1912 56.5534 30.5505 55.8582 31.0849 55.3095L36.9581 49.3438C37.3025 48.9927 37.7134 48.7138 38.1668 48.5233C38.6202 48.3329 39.1071 48.2348 39.5989 48.2348C40.0907 48.2348 40.5775 48.3329 41.031 48.5233C41.4844 48.7138 41.8953 48.9927 42.2396 49.3438C43.695 50.8214 43.695 53.2273 42.2396 54.7085L40.0538 56.9313L40.0723 56.9498C39.8134 57.1787 39.6111 57.4645 39.4811 57.7846C39.3512 58.1048 39.2972 58.4508 39.3233 58.7953C39.4177 60.0159 40.4699 60.9312 41.6719 60.8332C42.2451 60.7907 42.7481 60.5188 43.1143 60.1157L43.1161 60.1231L45.3482 57.8578C48.5104 54.6345 48.5104 49.416 45.3482 46.2038Z'
                    fill='#12D8AB'
                  />
                  <rect x='24.7012' y='112.281' width='15.7193' height='1.68421' fill='#8F98AF' />
                  <path
                    d='M17.4043 0H46.5973V2.73684C46.5973 4.94598 44.8064 6.73684 42.5973 6.73684H21.4043C19.1952 6.73684 17.4043 4.94598 17.4043 2.73684V0Z'
                    fill='url(#paint0_linear_1316_865)'
                  />
                  <circle cx='24.1404' cy='3.3689' r='1.12281' fill='#8F98AF' />
                  <defs>
                    <linearGradient
                      id='paint0_linear_1316_865'
                      x1='32.0008'
                      y1='0'
                      x2='32.0008'
                      y2='6.73684'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='#353C4A' />
                      <stop offset='1' stop-color='#222A38' />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <p className={`text-[24px] text-[#292C33] Dsm:text-[24px] pb-[10px] font-[600] mt-[60px] Dsm:mt-[24px] text-center`}>
                {t('Congratulations')}!
              </p>
              <p className='text-[16px] text-black text-center mt-[24px]'>
                {t("You have successfully completed extreme verification. Redirecting to the dashboard now")}...
              </p>
              <button onClick={() => {
                localStorage.setItem('showMessageAfterJump', 'true')
                window.location.href = '/dashboard'
              }}
                className='bg-[#FFCF55] rounded-[24px] h-[40px] flex items-center px-10 text-[15px] text-[#1B1C2B] font-[600] mx-auto mt-12'>
                {t('Go to Dashboard')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default One
